// extracted by mini-css-extract-plugin
export var footer = "_p4-5";
export var fulfillmentInput = "_p4-0";
export var shipDateInput = "_p4-1";
export var shipmentModal = "_p4-2";
export var shipmentModalContent = "_p4-3";
export var tableContainer = "_p4-4";